module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words-left-bar mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [(false) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent expand",
    on: {
      "click": _vm.toggleQueryExpand
    }
  }, [(_vm.queryExpand) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")]) : _vm._e(), _vm._v(" "), (!_vm.queryExpand) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))]), _vm._v(" "), _c('div', {
    staticClass: "query-controls"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function($event) {
        _vm.$emit('save')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function($event) {
        _vm.$emit('load')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_upload")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.queryExpand),
      expression: "queryExpand"
    }],
    staticClass: "mdl-card__supporting-text query-panel"
  }, [_c('div', [_c('WordsQuery', {
    attrs: {
      "columns": _vm.wordsColumnNames,
      "categories": _vm.categories,
      "query": _vm.query
    },
    on: {
      "update:query": _vm.handleQueryUpdate
    }
  })], 1), _vm._v(" "), _c('div', [_c('Checkbox', {
    attrs: {
      "checked": _vm.enableFilter,
      "label": _vm.i18n().filterResults
    },
    on: {
      "update:checked": _vm.handleEnableFilterUpdate
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97495e3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/words/WordsLeftBar.vue
// module id = 465
// module chunks = 0